import { createContext, useContext, ReactNode } from 'react'
import { useMerchant } from '../merchant/merchant-context'

interface FacebookContextType {
    purchaseFb: (data: FacebookEvents.Purchase) => void
    purchaseCAPI: (data: FacebookEvents.PurchaseCAPI) => void
}

const FacebookContext = createContext<FacebookContextType | undefined>(undefined)

export const FacebookProvider = ({ children }: { children: ReactNode }) => {

    const { merchantSummary } = useMerchant()

    const purchaseFb = (data: FacebookEvents.Purchase) => {
        if (!merchantSummary?.integrationsConfiguration?.facebookPixelId)
            return

        if (typeof window !== 'undefined' && (window as any).fbq) {
            (window as any).fbq('track', 'Purchase', {
                value: data.value,
                currency: data.currency
            }, { eventID: data.eventID })
        }
    }

    const purchaseCAPI = async (purchaseCAPI: FacebookEvents.PurchaseCAPI) => {
        if (!merchantSummary?.integrationsConfiguration?.facebookPixelId || !merchantSummary?.integrationsConfiguration?.facebookTokenCAPI) {
            return
        } else {
            try {
                const pixeId = merchantSummary.integrationsConfiguration.facebookPixelId
                const token = merchantSummary.integrationsConfiguration.facebookTokenCAPI

                const response = await fetch(`https://graph.facebook.com/v19.0/${pixeId}/events?access_token=${token}`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(purchaseCAPI),
                })

                if (!response.ok) {
                    throw new Error(`Erro ao enviar evento para Meta CAPI status: ${response.statusText}`)
                }
            } catch (err) {
                console.error("Erro ao enviar evento para Meta CAPI:", err)
            }
        }
    }

    return (
        <FacebookContext.Provider value={{ purchaseFb, purchaseCAPI }}>
            {children}
        </FacebookContext.Provider>
    )
}

export const useFacebook = (): FacebookContextType => {
    const context = useContext(FacebookContext)
    if (!context) {
        throw new Error('useFacebook deve ser usado dentro de um FacebookProvider')
    }
    return context
}